<template>
  <div>
    <h1 class="text-h1 mb-16">Welcome! Your employer-sponsored Premium access is now active.</h1>
    <p class="pb-16 text-body text-grey-body">It looks like you already had a Premium membership on Sittercity.</p>
    <p class="pb-16 text-body text-grey-body">
      If you recently paid for Premium and believe you may qualify for a refund, please contact our
      <a
        href="https://support.sittercity.com/hc/en-us/requests/new?ticket_form_id=5652055814427"
        class="underline"
        target="_blank"
        rel="noopener noreferrer"
        >support team</a
      >
      and we'll be happy to help review your account.
    </p>
    <Button class="w-full" variant="primary" value="Get started" size="medium" to="/account/seekers/dashboard" />
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';

export default {
  name: 'VerifyCorporateUpgradeExistingPremium',
  components: {
    Button,
  },
};
</script>
